<template>
    <a-card>
      
    <div>
        <h3 style="text-align: center;margin:20px 0 40px">合作单位信息</h3>
        <a-form layout="horizontal" :label-col="labelCol" :wrapper-col="wrapperCol"  ref="ruleForm" labelAlign="right" :model="form" :rules="rules" >
            <!--可编辑区域 start-->
            <div class="hidden">
                <!-- <div > -->
                <a-form-item label="ID主键" name="id">
                    <a-input v-model:value="form.id" placeholder="请输入ID主键" />
                </a-form-item>
                <a-form-item label="项目ID" name="projectId">
                    <a-input v-model:value="form.projectId" placeholder="请输入项目ID" />
                </a-form-item>
                <a-form-item label="分类ID" name="classification">
                    <a-input v-model:value="form.classification" placeholder="请输入分类ID" />
                </a-form-item>
                
            </div>

            <a-row :gutter="20">

                <a-col :span="12">
                    <a-form-item label="单位名称" name="unitName">
                        <a-input v-model:value="form.unitName" placeholder="请输入单位名称" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="单位性质" name="unitNature">
                        <DictSelect v-model:value="form.unitNature" :dict-name="'businessScope'" style="margin: -5px 0"
                          placeholder="请选择单位性质" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="组织机构代码" name="organizationCode">
                        <a-input v-model:value="form.organizationCode" placeholder="请输入组织机构代码" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="信用等级" name="creditLevel">
                        <DictSelect v-model:value="form.creditLevel" :dict-name="'creditLevel'" style="margin: -5px 0"
                          placeholder="请选择信用等级" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="法人代表" name="legaRepresentative">
                        <a-input v-model:value="form.legaRepresentative" placeholder="请输入法人代表" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="法人手机号" name="corporatePhone">
                        <a-input v-model:value="form.corporatePhone" placeholder="请输入法人手机号" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="开户银行" name="bankDeposit">
                        <a-input v-model:value="form.bankDeposit" placeholder="请输入开户银行" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="账户" name="account">
                        <a-input v-model:value="form.account" placeholder="请输入账户" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="职工总数" name="workforceNumber">
                        <a-input-number style="width:100%" v-model:value="form.workforceNumber" placeholder="请输入职工总数" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="职工中高级人数" name="workforceLevelNumber">
                        <a-input-number style="width:100%" v-model:value="form.workforceLevelNumber" placeholder="请输入职工中高级人数" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="所在地" name="location">
                        <a-input v-model:value="form.location" placeholder="请输入所在地" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="通讯地址" name="mailAddress">
                        <a-input v-model:value="form.mailAddress" placeholder="请输入通讯地址" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="邮编" name="postalCode">
                        <a-input v-model:value="form.postalCode" placeholder="请输入邮编" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="传真" name="fax">
                        <a-input v-model:value="form.fax" placeholder="请输入传真" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="联系人姓名" name="contactName">
                        <a-input v-model:value="form.contactName" placeholder="请输入联系人姓名" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="联系人电话" name="contactTelephone">
                        <a-input v-model:value="form.contactTelephone" placeholder="请输入联系人电话" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="联系人手机号" name="contactPhone">
                        <a-input v-model:value="form.contactPhone" placeholder="请输入联系人手机号" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="联系人邮箱" name="contactEmail">
                        <a-input v-model:value="form.contactEmail" placeholder="请输入联系人邮箱" />
                    </a-form-item>
                </a-col>
                <a-col :span="24" style="margin-left:-98px">
                    <a-form-item label="单位和项目成员简况" name="unitProject">
                        <a-textarea v-model:value="form.unitProject" placeholder="请输入单位和项目成员简况" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <a-col :span="24" style="margin-left:-98px">
                    <a-form-item label="任务分工" name="taskDivision">
                        <a-textarea v-model:value="form.taskDivision" placeholder="请输入任务分工" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <a-col :span="24" style="margin-left:-98px">
                    <a-form-item label="合作协议名称" name="caName">
                        <a-textarea v-model:value="form.caName" placeholder="请输入合作协议名称" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <a-col :span="24" style="margin-left:-98px">
                    <a-form-item label="参与项目任务" name="ppTasks">
                        <a-textarea v-model:value="form.ppTasks" placeholder="请输入参与项目任务" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <a-col :span="24" style="text-align: center;">
                    <a-button type="primary" html-type="submit" @click="onSubmit">
                        合作单位信息保存
                    </a-button>
                </a-col>
            </a-row>
            <!--可编辑区域 end-->
        </a-form>
        
    </div>
    </a-card>
</template>
<script>
import { postAction, postJson } from "@/utils/http/service";
import { filterObj } from "@/utils/util";
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {projectCooperative} from "@/api/TechnologieprojekteApply";
import store from '@/store';
import DictSelect from "@/components/other/DictSelect";

export default {
    name: "合作单位信息",
    components: {DictSelect},

    mixins: [formMixin],
    data() {
        return {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 },
            form: {
                id: null,
                    projectId: store.getters.TechnologieTypeId.projectId,
                    classification: store.getters.TechnologieTypeId.classification,
                    leaderType: null,
                    unitName: null,
                    unitNature: null,
                    organizationCode: null,
                    creditLevel: null,
                    legaRepresentative: null,
                    corporatePhone: null,
                    bankDeposit: null,
                    account: null,
                    workforceNumber: null,
                    workforceLevelNumber: null,
                    location: null,
                    mailAddress: null,
                    postalCode: null,
                    fax: null,
                    contactName: null,
                    contactTelephone: null,
                    contactPhone: null,
                    contactEmail: null,
                    unitProject: null,
                    taskDivision: null,
                    caName: null,
                    ppTasks: null,
            },
            rules: {
                id: [
                        
                    ],
                    projectId: [
                        dataCheck.required({}),
                    ],
                    classification: [
                        dataCheck.required({}),
                    ],
                    leaderType: [
                        dataCheck.required({}),
                    ],
                    unitName: [
                        dataCheck.required({}),
                    ],
                    unitNature: [
                        dataCheck.required({}),
                    ],
                    organizationCode: [
                        dataCheck.required({}),
                    ],
                    creditLevel: [
                        dataCheck.required({}),
                    ],
                    legaRepresentative: [
                        dataCheck.required({}),
                    ],
                    corporatePhone: [
                        dataCheck.required({}),
                    ],
                    bankDeposit: [
                        dataCheck.required({}),
                    ],
                    account: [
                        dataCheck.required({}),
                    ],
                    workforceNumber: [
                        dataCheck.required({type:"number"}),
                    ],
                    workforceLevelNumber: [
                        dataCheck.required({type:"number"}),
                    ],
                    location: [
                        dataCheck.required({}),
                    ],
                    mailAddress: [
                        dataCheck.required({}),
                    ],
                    postalCode: [
                        dataCheck.required({}),
                    ],
                    fax: [
                        dataCheck.required({}),
                    ],
                    contactName: [
                        dataCheck.required({}),
                    ],
                    contactTelephone: [
                        dataCheck.required({}),
                    ],
                    contactPhone: [
                        dataCheck.required({}),
                    ],
                    contactEmail: [
                        dataCheck.required({}),
                    ],
                    unitProject: [
                        dataCheck.required({}),
                    ],
                    taskDivision: [
                        dataCheck.required({}),
                    ],
                    caName: [
                        dataCheck.required({}),
                    ],
                    ppTasks: [
                        dataCheck.required({}),
                    ],
            },

            options: [],

        }
    },
    
    computed: {
            submitUrl() {
                return projectCooperative.saveOrUpdate
            }
        },
    mounted() {
        if(this.$route.query.id){
            this.onEdit()
        }
    },
    methods: {
         /*提交表单操作*/
         onSubmit() {
            if (!this.submitUrl) {
                this.$notification.warning({
                    message: '提示',
                    description: '请设置表单操作url地址',
                });
            } else {
                this.$refs.ruleForm
                    .validate()
                    .then(() => {
                        this.confirmLoading = true;
                        let params = this.transformParams
                            ? this.transformParams(this.form)
                            : this.form;
                            let action;
                        /*后台请求*/
                        if(this.submitType == 'json'){
                            action = postJson({
                                url: this.submitUrl,
                                params: filterObj(this.getSubmitParams(params)),
                                method: this.postMethod,
                                returnMsg: true
                            })
                        }else{
                            action=  postAction({
                                url: this.submitUrl,
                                params: filterObj(this.getSubmitParams(params)),
                                method: this.postMethod,
                                returnMsg: true
                            })
                        }
                        action.then((res) => {
                            this.$parent.$parent.postData(res.data.classification,res.data.projectId)
                            this.confirmLoading = false;
                            this.$notification.success({
                                message: '提示',
                                description: res.msg || '操作成功',
                            });
                            if (this.onSuccessFn) {
                                this.onSuccessFn(res);
                            }
                            if (this.isModal) {
                                this.$emit('finish');
                                this.onClose();
                            }
                        }).catch(() => {
                            this.confirmLoading = false;
                        })
                    })
                    .catch(error => {
                        if(error.errorFields.length){
                            this.$parent.$parent.errorSet()
                            this.$notification.error({
                                message: '请检查必填项，必填项目不能不填',
                            });
                        }
                        window.console.log('error', error);
                    });
            }
        },
        onEdit() {
            this.getAction({
                url: projectCooperative.detailByProject,
                params: { 
                    projectId: store.getters.TechnologieTypeId.projectId,
                    classification: store.getters.TechnologieTypeId.classification,
                 }
            }).then(res => {
                if(res){
                    this.form = res
                }
            })
        },
    },
}
</script>
<style scoped lang="less">
:deep(.ant-modal-body) {
    height:100vh!important;
    max-height: 100vh!important;
     }
</style>
